import "./banner.css";
import { useEffect } from "react";
import ContectUs from "../../Templates/Common/ContactUs";
import { useLocation, Link } from "react-router-dom";

function Banner() {

    const choice = useLocation().state.choice;
    const fatureData = ["Used for", "Ad Type", "Lead Time (in days)", "Proof of execution (in days)", "Span"]
    
    useEffect(() => {},[choice])

    return (
        <>
            <div className="mx-auto container pl-3 pr-3   grid lg:grid-cols-3 grid-cols-1 gap-10 mt-10 mb-10">
                <div className="lg:col-span-2 col-span-1 ">
                    {/* Header Start */}
                    <div className="flex items-center justify-between">
                        <div className="flex">
                            <img className="mr-3" style={{height: "55px", width: "55px"}} src={require(`../../assets/${ choice.imgBrand}.png`)} alt="instagram"/>
                            <div>
                                <h1 className="font-bold text-xl">{choice.heading}</h1>
                                <p className="flex items-center text-xs text-zinc-600">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="#cf102d"  >
                                        <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                    </svg>&nbsp;
                                    {choice.monthyUsers} Monthly Users&nbsp;
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" viewBox="0 0 20 20" fill="#cf102d">
                                        <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" />
                                        <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" />
                                    </svg>&nbsp;
                                    Social Media
                                </p>
                            </div>
                        </div>
                        <button style={{backgroundColor: "#09ac5b"}} className="pl-8 pr-8 pt-2 pb-2 sm:block hidden text-white rounded-3xl">Popular</button>
                    </div>
                    {/* Header End */}
                    <div className="mt-10 mb-8">
                        <h1 className="font-bold text-lg mb-2" style={{color: "#cf102d"}}>Description</h1>
                        <p className="text-gray-600 text-xs">{choice.description}</p>
                    </div>
                    <div>
                        <h1 className="font-bold text-lg mb-2 items-center" style={{color: "#cf102d"}}>Features</h1>
                        <div className="grid sm:grid-cols-5 grid-col-2">
                            {fatureData.map((item, i) => {
                                return <FeaturesItem key={i} textTop={item} textBottom={choice.detail[i]} />
                            })}
                        </div>
                        {choice.productDescription  && 
                            <>
                                <div className="divider bg-red-100 mt-8 mb-8"></div>
                                <div>
                                    <h1 className="font-bold text-lg mb-2 items-center" style={{color: "#cf102d"}}>Execution Details</h1>                           
                                    <div className="grid sm:grid-cols-2 grid-cols-1 gap-10">
                                        <ExtentionDetail heading="Dimension" paragraphArray={choice.productDescription[0]}/>
                                        <ExtentionDetail heading="Execution click Throught Rate" paragraphArray={choice.productDescription[1]}/>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
                <div className="col-span-1 flex flex-col justify-between ">
                <div>
                    <div className="mb-8">
                        <img className="w-full" src={require(`./../../assets/${choice.img[0]}`)} alt="top"/>
                        <div className="grid grid-cols-3 mt-3">
                            <img className="col-span-1" src={require(`./../../assets/${choice.img[2]}`)} alt="top"/>
                            <img className="col-span-1" src={require(`./../../assets/${choice.img[1]}`)} alt="top"/>
                            <img className="col-span-1" src={require(`./../../assets/${choice.img[2]}`)} alt="top"/>
                        </div>
                    </div>
                    <div className="flex sm:flex-row flex-col justify-center gap-5">
                        <RateButton prise={choice.price} />
                        <RateButton prise={choice.price} />
                    </div>
                </div>
                <div className="text-center">
                    <p className="mb-2 text-xs font-bold">Comming Billing<span className="text-xxs text-zinc-600">&nbsp;₹ 20.000</span></p>
                    <Link to="/payment/cart">
                        <button className="bg-green-600 w-full pt-2 pb-2 rounded-2xl text-white">shopping-cart Add to cart</button>
                    </Link>
                </div>
                </div>
            </div>
            <ContectUs />
        </>
    )
}

function FeaturesItem({textTop, textBottom}) {
    return (
        <div className="col-span-1 flex-auto">
            <h1 className="font-bold">{textTop}</h1>
            <p className="text-gray-600 text-xs">{textBottom}</p>
        </div>
    )
}

function ExtentionDetail({heading, paragraphArray}) {
    return (
        <div className="col-span-1">
            <h1 className="font-bold">{heading}</h1>
            {paragraphArray.map((text, i) => {
                return <p key={i} className="text-gray-600 mb-2 text-xs">{text}</p>
            })}
        </div>
    )
}

function RateButton({prise}) {
    return (
        <button className="price-button pt-2 pb-2 pl-5 pr-5 rounded-3xl font-bold">
            <div className="sm:text-left text-center">
                <p className="text-xs">Rack Rate</p>
                <p>{prise}</p>
            </div>
        </button>
    )
}

export default Banner;